module.exports = __webpack_public_path__ + "img/charity_4.f84f02f3.png";